export default  function initializeCollapse() {
    var collapseElementList = [].slice.call(document.querySelectorAll('.collapse'));
    if(collapseElementList.length === 0) {
        return;

    }
    return import('bootstrap/js/index.esm').then(({Collapse}) => {
        var collapseList = collapseElementList.map(function (collapseEl) {
            return new Collapse(collapseEl, {
                toggle: collapseEl.classList.contains('show')
            });
        });
    });

}